import { render, staticRenderFns } from "./DeleteResolution.vue?vue&type=template&id=5dce2f91&"
import script from "./DeleteResolution.vue?vue&type=script&lang=js&"
export * from "./DeleteResolution.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports